// @flow
import type { AppConfig, Activity, Location, ProductGroupName, ProductGroup, Theme } from "./types"

export type ChooseActivity = {|
  type: "APP/CHOOSE_ACTIVITY",
  payload: Activity,
|}
export const chooseActivity = (a: Activity): ChooseActivity => ({
  type: "APP/CHOOSE_ACTIVITY",
  payload: a,
})

export type ChooseProductGroups = {|
  type: "APP/CHOOSE_PRODUCTGROUP",
  payload: ProductGroup[],
|}

export const chooseProductGroups = (productGroups: ProductGroup[]): ChooseProductGroups => ({
  type: "APP/CHOOSE_PRODUCTGROUP",
  payload: productGroups,
})

export const setAppConfig = (appConfig: AppConfig) => ({
  type: "APP/SET_CONFIG",
  payload: appConfig,
})

export const setTheme = (theme: Theme) => ({
  type: "APP/SET_THEME",
  payload: theme,
})

export const prefetchGeolocations = (geolocations: {
  [ProductGroupName]: Location[],
}) => ({
  type: "APP/PREFETCH_GEOLOCATIONS",
  payload: geolocations,
})

export const setAllProductGroups = (productGroups: ProductGroup[]) => ({
  type: "APP/SET_ALL_PRODUCT_GROUPS",
  payload: productGroups,
})

export const chooseGeolocation = (g: Location[]) => ({
  type: "APP/CHOOSE_GEOLOCATION",
  payload: g,
})

export type HideGDPR = {|
  type: "APP/HIDE_GDPR",
|}
export const hideGDPR = (): HideGDPR => ({
  type: "APP/HIDE_GDPR",
})

export type ChooseRedirectCallback = {|
  type: "APP/CHOOSE_REDIRECT_CALLBACK",
  payload: Function,
|}
export const chooseRedirectCallback = (redirectCallback: Function): ChooseRedirectCallback => ({
  type: "APP/CHOOSE_REDIRECT_CALLBACK",
  payload: redirectCallback,
})


// WEBPACK FOOTER //
// ./src/data/app/actions.js